module.exports = __webpack_public_path__ + "static/media/colmeia_logo.8c23c120.png";